import { Box, Modal } from "@mui/material";
import React, { useCallback, useState } from "react";
import { CloseModalIcon } from "../../../common/components/assets/commonassets/CommonAssets";
import CommonDivider from "../../../common/components/divider/CommonDivider";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import SearchDropdown from "../../../common/components/FormFields/searchDropdown";
import InputField from "../../../common/components/FormFields/InputField";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import InputArea from "../../../common/components/FormFields/InputArea";
import DatePickerField from "../../../common/components/FormFields/DatePickerField";
import ConfirmationModal from "../../../common/components/ConfirmationModal";
import { format } from "date-fns";
import {
  errorAlert,
  successAlert,
} from "../../../common/components/Toasts/CustomToasts";
// import PatientInfo from "../emr/oncologyEMR/PatientInfo";

export const ModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  height: "85%",
  bgcolor: "background.paper",
  border: "1px solid gray",
  borderRadius: 1,
  boxShadow: 20,
  overflowY: "scroll",
  p: 4,
};

const ObstetricItems = [
  {
    id: 1,
    label:
      "To diagnose intra-uterine and/or ectopic pregnancy and confirm viability.",
    isChecked: false,
  },
  { id: 2, label: "Estimation of gestational age (dating).", isChecked: false },
  {
    id: 3,
    label: "Detection of number of foetuses and their chorionicity.",
    isChecked: false,
  },
  {
    id: 4,
    label:
      "Suspected pregnancy with IUCD in-situ or suspected pregnancy following contraceptive failure / MTP failure.",
    isChecked: false,
  },
  { id: 5, label: "Vaginal bleeding / leaking.", isChecked: false },
  { id: 6, label: "Follow-up of cases of abortion.", isChecked: false },
  {
    id: 7,
    label: "Assessment of cervical canal and diameter of internal os.",
    isChecked: false,
  },
  {
    id: 8,
    label: "Discrepancy between uterine size and period of amenorrhoea.",
    isChecked: false,
  },
  {
    id: 9,
    label: "Any suspected adnexal or uterine pathology / abnormality.",
    isChecked: false,
  },
  {
    id: 10,
    label:
      "Detection of chromosomal abnormalities, foetal structural defects and other abnormalities and their follow-up.",
    isChecked: false,
  },
  {
    id: 11,
    label: "To evaluate foetal presentation and position.",
    isChecked: false,
  },
  { id: 12, label: "Assessment of liquor amnii.", isChecked: false },
  {
    id: 13,
    label: "Preterm labour / preterm premature rupture of membranes.",
    isChecked: false,
  },
  {
    id: 14,
    label:
      "Evaluation of placental position, thickness, grading and abnormalities (placenta praevia, retroplacental haemorrhage, abnormal adherence, etc.).",
    isChecked: false,
  },
  {
    id: 15,
    label:
      "Evaluation of umbilical cord – presentation, insertion, nuchal encirclement, number of vessels and presence of true knot.",
    isChecked: false,
  },
  {
    id: 16,
    label: "Evaluation of previous Caesarean Section scars.",
    isChecked: false,
  },
  {
    id: 17,
    label:
      "Evaluation of foetal growth parameters foetal weight and foetal well being.",
    isChecked: false,
  },
  {
    id: 18,
    label: "Colour flow mapping and duples doppler studies",
    isChecked: false,
  },
  {
    id: 19,
    label:
      "Ultrasound guided procedures such as medical termination of pregnancy, extemel cephalic version etc, and their follow-up.",
    isChecked: false,
  },
  {
    id: 20,
    label:
      "Adjunct to diagnostic and therapeutic invasive interventions such as chorionic villus sampling (CVS), amniocentases, foetal blood sampling, foetal skin biopsy, amnio-infusion, intrauterine infusion, placement of shunts etc.",
    isChecked: false,
  },
  {
    id: 21,
    label: "Observation of intra-partum events.",
    isChecked: false,
  },
  {
    id: 22,
    label: "Medical/Surgical conditions complicating pregnancy.",
    isChecked: false,
  },
  {
    id: 23,
    label: "Research/scientific studies in recognised institutions",
    isChecked: false,
  },
];

const GynaecologyItems = [
  {
    id: 1,
    label: "Suspected uterine or adnexal pathology.",
    isChecked: false,
  },
  { id: 2, label: "Ovulation Monitoring.", isChecked: false },
  {
    id: 3,
    label:
      "Suspected intra abdominal / renal / gall bladder / hepatic pathology.",
    isChecked: false,
  },
];


function ReqInvestigationFormModal(props) {
  const {
    openReqInvmodal,
    setopenInvModal,
    patientDetails,
    editData,
    patientInfoApi,
    bloodgroupValue,
  } = props;


  const defaultValues = {
    refDoctor: null,
    patientName: "",
    age: "",
    g: "",
    p: "",
    a: "",
    lmp: null,
    riskFactor: "",
    anyothers: "",
  };

  const schema = yup.object().shape({
    refDoctor: yup.object().nullable().required("required"),
    patientName: yup.string().trim().required("patientName is required"),
    age: yup.string().required("Age is required"),
    g: yup.number().typeError("invalid").required("g is required"),
    p: yup.number().typeError("invalid").required("p is required"),
    a: yup.number().typeError("invalid").required("a is required"),
    lmp: yup.date().required("From date is required").typeError("Invalid date"),
    riskFactor: yup.string().trim().required("patientName is required"),
  });

  const {
    control,
    handleSubmit,
    reset,
    setValue,
    clearErrors,
    watch,
    getValues,
    setError,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues,
    resolver: yupResolver(schema),
  });

  const [refDoctorOptions, setRefDoctorOptions] = useState([]);
  const [obstetricItems, setObstetricItems] = useState(ObstetricItems);
  const [gynaecologyItems, setGynaecologyItems] = useState(GynaecologyItems);
  const [postConfirmationModal, setPostConfirmationModal] = useState(false);
  const [finalObject, setFinalObject] = useState(null);

  console.log("The patient details on the request modal are :", patientDetails);

  const handleCheck = useCallback(
    (selectedItem) => {
      setObstetricItems((prevData) =>
        prevData.map((item) =>
          item.id === selectedItem.id
            ? { ...item, isChecked: !item.isChecked }
            : item
        )
      );
    },
    [obstetricItems]
  );

  const handleCheckGynaecology = useCallback(
    (selectedItem) => {
      setGynaecologyItems((prevData) =>
        prevData.map((item) =>
          item.id === selectedItem.id
            ? { ...item, isChecked: !item.isChecked }
            : item
        )
      );
    },
    [gynaecologyItems]
  );
  console.log("selected", obstetricItems, gynaecologyItems);

  const handleSaveClick = (data) => {
    const isAnyobstetricChecked = obstetricItems.some((item) => item.isChecked);
    const isAnygynaecologyChecked = gynaecologyItems.some(
      (item) => item.isChecked
    );

    let tempobj = {
      refDoctor: data?.refDoctor?.id ? { id: data?.refDoctor?.id } : null,
      visitId: { id: 1 },
      patientId: { id: 1 },
      age: data?.age,
      g: data?.g,
      p: data?.p,
      a: data?.a,
      lmpDate: data?.lmp ? format(new Date(data.lmp), "yyyy-MM-dd") : null,
      riskFactor: data?.riskFactor,
      obstetricObservationList: obstetricItems,
      gynaecologyObservationList: gynaecologyItems,
      otherDescription: data?.anyothers,
    };
    
    setFinalObject(tempobj);
    console.log("tempObjj", tempobj);

    setPostConfirmationModal(true);
  };
  const onSubmit = () => {};

  React.useEffect(() => {
    if (props?.editData !== undefined && props?.editData !== null) {
      setValue("riskFactor", props?.editData?.highRiskFactor);
    }
  }, [props?.editData]);
  return (
    <Modal
      open={openReqInvmodal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={ModalStyle}
        className="w-[70%] max-h-[90%] overflow-auto rounded-lg"
      >
        <div className="flex justify-between  items-center">
          <h1 className=" font-bold text-[18px]">Request For Investigations</h1>
          <CloseModalIcon
            type={"button"}
            onClick={() => {
              setopenInvModal(false);
            }}
          />
        </div>
        {/* <PatientInfo
          patientInfo={patientDetails}
          editData={editData}
          patientInfoApi={patientInfoApi}
          bloodgroupValue={bloodgroupValue}
        /> */}
        <CommonDivider color="" />
        <form onSubmit={handleSubmit(handleSaveClick)}>
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 items-center my-2">
            <SearchDropdown
              control={control}
              name="refDoctor"
              placeholder="Ref. Doctor"
              dataArray={refDoctorOptions}
              isClearable={true}
              handleInputChange={(e) => {
              }}
              searchIcon={true}
              error={errors.refDoctor}
            />
           
            <div className="flex items-center gap-2">
              <InputField
                control={control}
                label="G"
                name="g"
                type={"number"}
                error={errors.g}
              />
              <InputField
                control={control}
                label="P"
                name="p"
                type={"number"}
                error={errors.p}
              />
              <InputField
                control={control}
                label="A"
                name="a"
                type={"number"}
                error={errors.a}
              />
            </div>
            <div className="flex items-center gap-2">
              <DatePickerField
                name="lmp"
                label="LMP"
                control={control}
                inputFormat="dd/MM/yyyy"
                slotProps={{ textField: { size: "small" } }}
                error={errors.lmp}
              />
            </div>
            <InputField
              control={control}
              label="Risk Factor"
              name="riskFactor"
              type={"text"}
              error={errors.riskFactor}
            />
          </div>
          <h2 className="font-semibold mt-3">OBSTETRIC</h2>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "40px 40px 1fr",
              border: "1px solid #ccc",
              width: "100%",
              maxHeight: "90%",
              borderCollapse: "collapse",
              fontFamily: "Arial, sans-serif",
              fontSize: "14px",
              height: "500px",
              overflowY: "scroll",
            }}
          >
            {obstetricItems?.map((item, index) => (
              <React.Fragment key={item.id}>
                {/* Sr.No */}
                <div
                  style={{
                    borderBottom:
                      index !== obstetricItems?.length - 1
                        ? "1px solid #ccc"
                        : "none",
                    borderRight: "1px solid #ccc",
                    padding: "8px",
                    textAlign: "center",
                    background: item?.isChecked ? "#f0f8ff" : "#fff",
                  }}
                >
                  {item.id}
                </div>

                {/* Checkbox */}
                <div
                  style={{
                    borderBottom:
                      index !== obstetricItems?.length - 1
                        ? "1px solid #ccc"
                        : "none",
                    borderRight: "1px solid #ccc",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: item?.isChecked ? "#f0f8ff" : "#fff",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={item?.isChecked || false}
                    onChange={() => handleCheck(item)}
                    style={{
                      width: "10px",
                      height: "10px",
                      transform: "scale(1.5)",
                      cursor: "pointer",
                    }}
                  />
                </div>

                {/* Description */}
                <div
                  style={{
                    borderBottom:
                      index !== obstetricItems.length - 1
                        ? "1px solid #ccc"
                        : "none",
                    padding: "8px",
                    background: item?.isChecked ? "#f0f8ff" : "#fff",
                  }}
                >
                  {item.label}
                </div>
              </React.Fragment>
            ))}
          </div>

          <h2 className="font-semibold mt-3">GYNAECOLOGY</h2>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "40px 40px 1fr",
              border: "1px solid #ccc",
              width: "100%",
              borderCollapse: "collapse",
              fontFamily: "Arial, sans-serif",
              fontSize: "14px",
            }}
          >
            {gynaecologyItems.map((item, index) => (
              <React.Fragment key={item.id}>
                {/* Sr. No */}
                <div
                  style={{
                    borderBottom:
                      index !== gynaecologyItems.length - 1
                        ? "1px solid #ccc"
                        : "none",
                    borderRight: "1px solid #ccc",
                    padding: "6px",
                    textAlign: "center",
                    background: item?.isChecked ? "#faf5ff" : "#fff",
                  }}
                >
                  {index + 1}
                </div>

                {/* Checkbox */}
                <div
                  style={{
                    borderBottom:
                      index !== gynaecologyItems.length - 1
                        ? "1px solid #ccc"
                        : "none",
                    borderRight: "1px solid #ccc",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: item?.isChecked ? "#faf5ff" : "#fff",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={item?.isChecked}
                    onChange={() => handleCheckGynaecology(item)}
                    style={{
                      width: "10px",
                      height: "10px",
                      transform: "scale(1.5)",
                      cursor: "pointer",
                    }}
                  />
                </div>

                {/* Description */}
                <div
                  style={{
                    borderBottom:
                      index !== gynaecologyItems.length - 1
                        ? "1px solid #ccc"
                        : "none",
                    padding: "8px",
                    background: item?.isChecked ? "#faf5ff" : "#fff",
                  }}
                >
                  {item.label}
                </div>
              </React.Fragment>
            ))}
          </div>
          <div className="my-2">
            <InputArea
              control={control}
              name="anyothers"
              label={"Any others"}
              minRows={3}
              maxRows={3}
            />
          </div>
          <div className="flex justify-end gap-3  mt-3 ">
            <CommonButton
              type="button"
              label="Reset"
              className="resetButton text-customRed border border-customRed"
              onClick={() => {
                reset(defaultValues);
                setObstetricItems(ObstetricItems);
                setGynaecologyItems(GynaecologyItems);
              }}
            />
            <CommonButton
              type="submit"
              label="Save&Print"
              className="saveButton bg-customGreen text-white "
            />
          </div>
        </form>
        {postConfirmationModal && (
          <ConfirmationModal
            confirmationOpen={postConfirmationModal}
            confirmationHandleClose={() => setPostConfirmationModal(false)}
            confirmationSubmitFunc={onSubmit}
            confirmationMsg={`Are you sure to save the investigation form?`}
            confirmationButtonMsg={"Confirm"}
            confirmationLabel={"Confirmation"}
          />
        )}
      </Box>
    </Modal>
  );
}

export default ReqInvestigationFormModal;
